export const baseRoute = '/o/:orgId';

export const visitorWelcomeRoute = 'welcome';

export const visitorTrialEndRoute = 'trial-end';

export const visitorRoutes = {
  dashboard: 'dashboard',
  visitors: 'visitors',
  bulkSchedule: 'visitors/bulkSchedule',
  visitorSearchResults: 'visitorSearchResults',
  locations: 'locations',
  kiosks: 'kiosks',
  redFlag: 'redFlag',

  reports: {
    root: 'reports',
    visitorReport: 'reports/visitorReport',
    visitorsHourlyReport: 'reports/visitorsHourlyReport',
    repeatVisitors: 'reports/repeatVisitors',
    redFlagReport: 'reports/redFlagReport',
    hostReport: 'reports/hostReport',
    activityLog: 'reports/activityLog',
    guestPassReport: 'reports/guestPassReport',
    guestPassLog: 'reports/guestPassLog',
  },

  configuration: {
    root: 'configuration',
    invitations: 'configuration/invitations',
    badgeTemplate: 'configuration/badgeTemplate',
    workflow: 'configuration/workflow',
    formFields: 'configuration/formFields',
    agreements: 'configuration/agreements',
    users: 'configuration/users',
    userRoles: 'configuration/userRoles',
    emailTemplates: 'configuration/emailTemplates',
    avigilonReaders: 'configuration/avigilonReaders',
  },

  administration: {
    root: 'administration',
    integration: 'administration/integration',
  },
  mobile: 'mobile',
};
